import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectToolCollection } from "../../../actions";
import PaperColor from "./PaperColor";
import Dialog from "../../Dialog";
import "./ColorTools.css";
import localStorageWrapper from "../../../services/localStorageWrapper";
import { useEffect } from "react";

class ColorTools extends React.Component {
  state = {
    showContrastDialog: false,
    showCanvasPhotoFoilNote: false
  };

  componentDidMount() {
    // Set 'Color' as the selected tool in the sidebar
    this.props.selectToolCollection({ activeTool: "Color" });

    this.contrastDialog = {
      title: "Designer's Tip",
      message:
        "Contrasting imprint and product colors will make your design pop, tone on tone is subtle and elegant.",
      topPosition: 150,
      leftPosition: 20,
      origin: "topleft"
    };

    this.canvasPhotoFoilNote = {
      title: "WARNING!",
      message:
        "NOTE: Upcharge applies for foil printing on custom photo products.",
      topPosition: 390,
      leftPosition: 125,
      origin: "topleft",
      type: "warning"
    };

    // Expiration for local storage
    const now = Date.now(),
      expires = 60 * 60 * 1000 * 24;

    if (
      !this.state.showContrastDialog &&
      !this.state.showCanvasPhotoFoilNote &&
      !localStorageWrapper.getItem("fypColorDialogsShown")
    ) {
      // Set local storage for 24 hours to remember that the tips have been shown
      localStorageWrapper.setItem("fypColorDialogsShown", true);
      localStorageWrapper.setItem("fypColorDialogsShownTimestamp", now);

      this.setState({
        showContrastDialog: true,
        showCanvasPhotoFoilNote: true
      });
    }

    // Delete local storage after 24 hours
    if (
      now - localStorageWrapper.getItem("fypColorDialogsShownTimestamp") >
      expires
    ) {
      localStorageWrapper.removeItem("fypColorDialogsShown");
      localStorageWrapper.removeItem("fypColorDialogsShownTimestamp");
    }

    // Add a global handler for the contrast dialog dismiss
    window.dismissContrastDialog = () => {
      if (this.state.showContrastDialog) {
        this.handleHideContrastDialog();
        return true;
      }
      return false;
    };

    // Save reference as a class property for cleanup
    this.handleDocumentClick = (e) => {
      // If the contrast dialog is showing
      if (this.state.showContrastDialog) {
        // First check for direct match on the confirm button element
        const confirmButton = document.querySelector(
          ".tools-container--colortools .dialog__confirm"
        );
        if (confirmButton) {
          // Check if the button or any of its children were clicked
          if (confirmButton.contains(e.target)) {
            e.preventDefault();
            e.stopPropagation();
            this.handleHideContrastDialog();
            return;
          }

          // Check if we're clicking close enough to the button
          const buttonRect = confirmButton.getBoundingClientRect();
          const clickProximity = 15; // Allow clicks within this many pixels of the button

          if (
            Math.abs(e.clientX - (buttonRect.left + buttonRect.width / 2)) <
              clickProximity &&
            Math.abs(e.clientY - (buttonRect.top + buttonRect.height / 2)) <
              clickProximity
          ) {
            e.preventDefault();
            e.stopPropagation();
            this.handleHideContrastDialog();
            return;
          }
        }

        // Fallback to the dialog region detection
        const dialogElement = document.querySelector(
          ".tools-container--colortools .dialog"
        );
        if (dialogElement) {
          const rect = dialogElement.getBoundingClientRect();
          // Define the close button area (top-right corner of dialog)
          const closeAreaX = rect.right - 30;
          const closeAreaY = rect.top + 30;

          // If the click is in this area, close the dialog
          if (
            e.clientX >= closeAreaX &&
            e.clientX <= rect.right &&
            e.clientY >= rect.top &&
            e.clientY <= closeAreaY
          ) {
            e.preventDefault();
            e.stopPropagation();
            this.handleHideContrastDialog();
          }
        }
      }
    };

    // Add both click and touch handlers for better mobile support
    document.addEventListener("click", this.handleDocumentClick);
    document.addEventListener("touchstart", this.handleDocumentClick);
  }

  handleHideContrastDialog = (e) => {
    // Force immediate update to state
    this.setState({
      showContrastDialog: false
    });

    // Ensure we update localStorage
    const now = Date.now();
    if (!localStorageWrapper.getItem("fypColorDialogsShown")) {
      localStorageWrapper.setItem("fypColorDialogsShown", true);
      localStorageWrapper.setItem("fypColorDialogsShownTimestamp", now);
    }

    // Prevent any default behavior if available
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  handleHidePhotoFoilDialog = () => {
    this.setState({
      showCanvasPhotoFoilNote: false
    });
  };

  componentWillUnmount() {
    // Clean up our event listeners
    document.removeEventListener("click", this.handleDocumentClick);
    document.removeEventListener("touchstart", this.handleDocumentClick);

    // Remove global handler
    delete window.dismissContrastDialog;
  }

  render() {
    const productInfo = this.props.productOption.entity;
    const dataTarget = "product_variant_id";
    const custom_photo_foil_var_ids = [
      287, 746, 747, 806, 808, 896, 897, 898, 899, 900, 901, 902, 903, 904, 905
    ];
    let isCustomPhotoFoil = false;

    if (productInfo) {
      custom_photo_foil_var_ids.map((id) => {
        if (productInfo[dataTarget] == id) {
          isCustomPhotoFoil = true;
        }
      });
    }

    return (
      <div className="tools-container tools-container--colortools">
        <div className="current-product-tools">
          {this.state.showContrastDialog && this.contrastDialog && (
            <Dialog
              dialog={this.contrastDialog}
              onHideDialog={this.handleHideContrastDialog}
            />
          )}
          {this.state.showCanvasPhotoFoilNote &&
            this.canvasPhotoFoilNote &&
            isCustomPhotoFoil == true && (
              <Dialog
                dialog={this.canvasPhotoFoilNote}
                onHideDialog={this.handleHidePhotoFoilDialog}
              />
            )}
          <PaperColor />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    productOption: state.productOption
  };
}

function mapDispatchToProps(dispatch) {
  // Pass result of selectToolCollection to reducers
  return bindActionCreators(
    {
      selectToolCollection
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ColorTools);
